export default {
  props: {
    statusMessage: {
      type: String,
      default: ''
    },
    canSubmit: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    }
  }
};